import { FormControl, UntypedFormGroup } from '@angular/forms';

export function Compare(control1: any, control2: any) {
    if (Number(control1.value) >= Number(control2.value)) {
        return control1.setErrors({ notMatch: true });
    }
}

// * compare details
export function CompareDates() {
    return function validate(formGroup: UntypedFormGroup) {
        let startDate = formGroup.get('startDate');
        let endDate = formGroup.get('endDate');

        let startDateValue = new Date(startDate.value);
        let endDateValue = new Date(endDate.value);

        if (startDateValue > endDateValue) {
            return { inValidStartDate: true };
        }
    };
}

// * compare two number values
export function CompareNumbers() {
    return function validate(formGroup: UntypedFormGroup) {
        let formControl1 = formGroup.get('minChar');
        let formControl2 = formGroup.get('maxChar');

        if (formControl1.valid && formControl2.valid) {
            if (Number(formControl1.value) > Number(formControl2.value)) {
                return { inValidMinMaxValue: true };
            }
        }
    };
}
